import React from 'react';
import { NavLink } from 'react-router-dom';

export default props => (
  <NavLink
    isActive={(_, { pathname }) => pathname === props.to.split('?')[0]}
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/common/PathNavLink/index.js